<ng-container *ngFor="let column of columns; index as i">
  <div class="uve-container blog-read-more-container" [class]="getRowCss(column, i)" [ngClass]="column.styleClass">
    <custom-dot-cms-container class="w-100" [layoutContainers]="column.containers"></custom-dot-cms-container>
  </div>
</ng-container>
